import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { ActionOutboxEntityType, Permission } from 'src/WebApiController';

import { useUserHasAnyOfPermissions } from './useUserHasAnyOfPermissions';

export const useUserHasTagTypePermissions = (
  entityType:
    | ActionOutboxEntityType.Listing
    | ActionOutboxEntityType.Purchase
    | ActionOutboxEntityType.Sale
    | ActionOutboxEntityType.SellerEvent
) => {
  const { loginContext } = useAppContext();

  const hasCreateTagPermission = useUserHasAnyOfPermissions(
    entityType === ActionOutboxEntityType.Listing
      ? Permission.Inventory_AddTagType
      : entityType === ActionOutboxEntityType.Sale
        ? Permission.Sales_AddTagType
        : entityType === ActionOutboxEntityType.Purchase
          ? Permission.Purchases_AddTagType
          : Permission.Events_AddTagType
  );

  const isNotConsignee = useMemo(
    () =>
      loginContext?.user?.activeAccount != null &&
      loginContext.user.activeAccount.isConsignee == false,
    [loginContext]
  );

  // TODO: Change this to correct one: https://thestubhub.atlassian.net/browse/POS-3668
  const hasManageTagTypePermission = useMemo(() => {
    return isNotConsignee && hasCreateTagPermission;
  }, [isNotConsignee, hasCreateTagPermission]);

  const hasEditTagTypePermission = useMemo(
    () => isNotConsignee,
    [isNotConsignee]
  );

  return {
    hasCreateTagTypePermission: hasManageTagTypePermission,
    hasDeleteTagTypePermission: hasManageTagTypePermission,
    hasEditTagTypePermission,
  };
};
